import React from 'react'

const SvgFaqOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M13.08 9.67V8.14c.527-.02.92-.107 1.18-.26.267-.16.4-.427.4-.8v-.14c0-.253-.077-.447-.23-.58-.147-.133-.34-.2-.58-.2-.26 0-.477.08-.65.24-.167.16-.28.363-.34.61l-1.22-.51a2.5 2.5 0 01.26-.58c.113-.193.26-.363.44-.51.187-.153.407-.277.66-.37.26-.093.56-.14.9-.14.347 0 .663.05.95.15.287.1.533.24.74.42.207.18.363.397.47.65.113.253.17.533.17.84 0 .28-.047.533-.14.76-.093.227-.22.427-.38.6-.16.167-.347.303-.56.41-.213.107-.437.18-.67.22v.72h-1.4zM13.8 12.12c-.32 0-.55-.073-.69-.22a.774.774 0 01-.2-.54v-.24c0-.213.067-.393.2-.54.14-.147.37-.22.69-.22.32 0 .547.073.68.22.14.147.21.327.21.54v.24c0 .213-.07.393-.21.54-.133.147-.36.22-.68.22z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 3.6A1.6 1.6 0 0020.4 2H7.6A1.6 1.6 0 006 3.6v9.6c0 .884.716 1.8 1.6 1.8H18l2.4 1.933L22 18V3.6zM18 13l2 1.5V4H8v9h10z'
    />
    <path d='M4 6.94h-.4A1.6 1.6 0 002 8.54V22l4.07-3h9.33a1.6 1.6 0 001.6-1.6V17H6a2 2 0 01-2-2V6.94z' />
  </svg>
)

export default SvgFaqOutline
